import React from "react";

export interface MapPinIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const MapPin: React.FC<MapPinIconProps> = ({ width = 14, height = 14, color = "#9A9AB0" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_15151_10)">
        <path
          d="M10.6658 5.83325C10.6657 4.86077 10.2799 3.92813 9.59253 3.24048C8.90497 2.55279 7.97203 2.16626 6.99976 2.16626C6.02758 2.16631 5.09547 2.55287 4.40796 3.24048C3.72042 3.92815 3.33377 4.86065 3.33374 5.83325C3.33374 6.95256 3.97351 8.21834 4.88062 9.4104C5.61394 10.3741 6.44359 11.184 6.99976 11.6877C7.55589 11.184 8.38552 10.3741 9.1189 9.4104C10.026 8.21834 10.6658 6.95256 10.6658 5.83325ZM7.74976 5.83325C7.7497 5.41882 7.41366 5.08325 6.99976 5.08325C6.58594 5.08335 6.24981 5.41888 6.24976 5.83325C6.24976 6.24768 6.58591 6.58315 6.99976 6.58325C7.41369 6.58325 7.74976 6.24774 7.74976 5.83325ZM9.74976 5.83325C9.74976 7.35194 8.51862 8.58325 6.99976 8.58325C5.48097 8.58315 4.24976 7.35188 4.24976 5.83325C4.24981 4.31467 5.48101 3.08335 6.99976 3.08325C8.51859 3.08325 9.7497 4.31461 9.74976 5.83325ZM12.6658 5.83325C12.6658 7.62678 11.6902 9.33416 10.7107 10.6213C9.70804 11.939 8.57129 12.9837 8.00366 13.4739L7.97827 13.4954L7.9519 13.5159C7.67756 13.7222 7.34305 13.8342 6.99976 13.8342C6.65658 13.8342 6.32285 13.7221 6.04858 13.5159L6.02124 13.4954L5.99585 13.4739C5.42822 12.9837 4.29147 11.939 3.28882 10.6213C2.30938 9.33418 1.33374 7.6267 1.33374 5.83325C1.33377 4.33048 1.93053 2.88917 2.99292 1.82642C4.05548 0.763651 5.49699 0.166309 6.99976 0.16626C8.50259 0.16626 9.94399 0.763607 11.0066 1.82642C12.0691 2.88918 12.6657 4.33039 12.6658 5.83325Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_15151_10">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapPin;
